import type { Nullish } from "~/@types/generics"
import { fetchSbStory } from "~/lib/storyblok/queries/fetch-sb-story"
import serializePanelMaterials from "~/components/ui/Collection/CollectionDefault/components/PanelMaterials/_data/serializer"

export async function fetchPanelMaterials(locale: Nullish<string>, currentMaterial: Nullish<string>) {
  const materials = await fetchSbStory("globals/material-panels/:slug", { locale }, { slug: currentMaterial ?? "" })

  return await serializePanelMaterials(materials?.data.story.content, locale)
}
